const OrderQuestionDataTypes = {
	TrueFalse: 1,
	MultipleChoice: 2,
	Number: 3,
	Text: 4,
	YesNo: 5,
	Str: 6
};

export default OrderQuestionDataTypes;
